import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Button, Message, Popup, Icon, Segment } from "semantic-ui-react";
import axios from "axios";
import { setError, setLoading } from "@cb/duck/basic";
import {
  onAddressBlur,
  onAddressChange,
  onAddressSelect,
} from "@cb/duck/address";
import {
  resetTerm,
  setAdditionalCost,
  setAdditionalCostNote,
  setDownPayment,
  setTerm,
  updateCalculatorData,
  updateDownPaymentOverride,
} from "@cb/duck/term";
import { TermPicker } from "./TermPicker";
import ViewOnly from "./ViewOnly";
import { Warning } from "@cb/components";
import { AddressLookup } from "components/shared";

import { addressValid } from "@cb/helpers/addressSchema";

class Term extends Component {
  state = {
    error: null,
    loading: false,
    plans: [],
    showPlans: false,
    taxRate: null,
  };

  componentDidMount = () => {
    this.props.dispatch(updateDownPaymentOverride(this.props.id));

    if (this.validateCalculateData()) {
      this.calculatePayment();
    } else {
      this.setState({ showPlans: false });
    }
  };

  validateCalculateData = () => {
    if (
      // this.props.term &&
      this.props.systems.length &&
      !this.props.payment &&
      this.props.county &&
      this.props.zip.length === 5 &&
      this.props.state &&
      addressValid(this.props.address)
    ) {
      return true;
    }

    return false;
  };

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.additionalCost !== this.props.additionalCost ||
      prevProps.downPayment !== this.props.downPayment ||
      prevProps.county !== this.props.county ||
      prevProps.state !== this.props.state ||
      prevProps.zip !== this.props.zip
    ) {
      this.setState({ showPlans: false });
    }

    if (
      prevProps.downPaymentOverrideAmount !==
        this.props.downPaymentOverrideAmount ||
      prevProps.purchaseReserveReduction !== this.props.purchaseReserveReduction
    ) {
      this.calculatePayment();
    }
  };

  calculatePayment = (e, ee, addressInfo = null) => {
    const { downPaymentOverrideAmount } = this.props;

    if (!this.validateCalculateData()) {
      return;
    }

    e ? e.preventDefault() : null;

    let downPaymentFormatted = this.props.downPayment
      ? parseFloat(this.props.downPayment) * 100
      : 0;
    const additionalCostFormatted = this.props.additionalCost
      ? parseFloat(this.props.additionalCost) * 100
      : 0;

    downPaymentFormatted += downPaymentOverrideAmount;

    let postData = {
      additional_down_payment: downPaymentFormatted,
      additional_cost: additionalCostFormatted,
      hvac_system_ids: this.props.systems.map((s) => s.id),
      state: this.props.state,
      zip: this.props.zip,
      contract_id: this.props.id,
    };

    if (this.props.purchaseReserveReduction) {
      postData.purchase_reserve_reduction =
        parseFloat(this.props.purchaseReserveReduction) * 100;
    }

    if (addressInfo) {
      postData.state = addressInfo.state;
      postData.zip = addressInfo.zip;
    }

    if (this.props.dealerId) {
      postData.dealer_id = this.props.dealerId;
    }

    this.setState({
      error: null,
    });

    this.props.dispatch(setLoading(true));

    axios
      .post("/contracts/calculate/", postData)
      .then(({ data }) => {
        let plans = [];
        Object.keys(data).forEach((k) => {
          if (k !== "tax_rate" && k !== "state") {
            plans.push({
              ...data[k],
              id: data[k].term,
              tax_rate: data.tax_rate,
            });
          }
        });

        if (this.props.isFinancial) {
          plans = plans.filter((p) => p.term !== "36");
        }

        // this means we have a selected term....
        // let's update the contract with the new term
        if (this.props.term) {
          const newTerm = plans.find((p) => p.term == this.props.term.term);
          if (newTerm) {
            this.props.dispatch(
              setTerm(
                {
                  ...newTerm,
                  additional_purchase_reserve: newTerm.additional_down_payment,
                  monthly_pretax: newTerm.pre_tax_monthly,
                },
                this.props.id
              )
            );
          }
        }

        this.setState({
          loading: false,
          plans,
          taxRate: data.tax_rate,
          showPlans: true,
        });
      })
      .then(() => this.props.dispatch(setLoading(false)))
      .catch((err) => {
        this.props.dispatch(setLoading(false));
        this.setState({
          error: err.response.data.ui_message,
        });

        setTimeout(() => {
          this.setState({ error: null });
        }, 5000);
      });
  };

  handleAdditionalCost = (d) => {
    if (!isNaN(d.value)) {
      let parsed = parseInt(d.value);

      if (parsed <= 1100) {
        this.props.dispatch(setAdditionalCost(d.value.trim()));
      }
    }

    if (d.value === "") {
      this.props.dispatch(setAdditionalCost(""));
    }
  };

  onAddressChange = (e) => {
    this.props.dispatch(
      onAddressChange({ name: e.target.name, value: e.target.value })
    );
    if (e.target.name === "state") {
      this.onAddressBlur(e);
    }
  };

  onAddressBlur = (e) => {
    this.props.dispatch(
      onAddressBlur({ [e.target.name]: e.target.value }, this.props.id)
    );
  };

  onAddressError = (badState) => {
    this.setState({
      error: `Atwood Rentals is not available in ${badState} yet. Enter a new address.`,
      plans: [],
      showPlans: false,
    });
  };

  onAddressSelect = (addressData) => {
    const formattedData = {
      address_1: `${addressData.street_number} ${addressData.street_name}`,
      city: addressData.city,
      state: addressData.state,
      county: addressData.county,
      zip: addressData.zip,
      latitude: addressData.lat,
      longitude: addressData.lng,
    };

    this.props.dispatch(onAddressSelect(formattedData, this.props.id));
    this.calculatePayment(null, null, {
      state: addressData.state,
      zip: addressData.zip,
    });
  };

  onTermClick = (termId) => {
    const term = this.state.plans.find((p) => p.id === termId);
    const newTerm = { ...term };

    if (!term) {
      return;
    }

    newTerm.additional_purchase_reserve = term.additional_down_payment;
    newTerm.monthly_pretax = term.pre_tax_monthly;

    this.props.dispatch(setTerm(newTerm, this.props.id));
  };

  render() {
    const { showPlans } = this.state;

    const { address, id, isFinancial } = this.props;

    if (this.props.payment) {
      return (
        <ViewOnly
          address={this.props.address}
          additionalCost={this.props.additionalCost}
          taxState={this.props.state}
          term={this.props.term}
          zip={this.props.zip}
        />
      );
    }

    if (!this.props.systems.length) {
      return (
        <Warning
          color="yellow"
          icon="ban"
          subheader={`You can't select a term without any systems selected.`}
          header="Hold Up!"
          step="systems"
        />
      );
    }

    const submitDisabled = () => {
      if (
        !this.props.county ||
        this.props.zip.length !== 5 ||
        !this.props.state ||
        this.state.error ||
        (parseFloat(this.props.additionalCost) &&
          !this.props.additionalCostNote) ||
        isNaN(this.props.downPayment)
      ) {
        return true;
      }
      return false;
    };

    return (
      <Segment padded>
        <Form size="large">
          <Form.Input
            label="Additional Contract Cost Reduction (optional)"
            error={isNaN(this.props.downPayment)}
            placeholder="$"
            value={this.props.downPayment}
            onBlur={(e, d) => {
              if (!isNaN(e.target.value) && parseFloat(e.target.value) > 0) {
                this.props.dispatch(
                  resetTerm(id, {
                    additional_purchase_reserve: e.target.value.trim(),
                  })
                );
              } else if (e.target.value === "" || e.target.value === "0") {
                this.props.dispatch(
                  resetTerm(id, {
                    additional_purchase_reserve: e.target.value.trim(),
                  })
                );
              }
            }}
            onChange={(e, d) => {
              if (!isNaN(d.value) && parseFloat(e.target.value) > 0) {
                this.props.dispatch(setDownPayment(d.value.trim()));
              } else if (e.target.value === "" || e.target.value === "0") {
                this.props.dispatch(setDownPayment(e.target.value.trim()));
              }
            }}
          />
          {this.props.downPaymentOverrideAmount > 0 && (
            <div>
              <p
                style={{
                  top: "-10px",
                  position: "relative",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                + ${(this.props.downPaymentOverrideAmount / 100).toFixed(2)}{" "}
                <Popup
                  trigger={
                    <Icon
                      circular
                      name="question"
                      size="tiny"
                      style={{ marginLeft: "10px" }}
                    />
                  }
                >
                  This contract includes an overriden system. This adds to the
                  required down payment.
                </Popup>
              </p>
            </div>
          )}
          {/* <Form.Input
            label={`Additional Cost (optional)`}
            placeholder="$"
            value={this.props.additionalCost}
            onBlur={(e, d) => {
              if (e.target.value === "") {
                this.props.dispatch(resetTerm(id, { additional_cost: "0" }));
              } else {
                if (parseInt(e.target.value) <= 1100) {
                  this.props.dispatch(
                    resetTerm(id, { additional_cost: e.target.value.trim() })
                  );
                }
              }
            }}
            onChange={(e, d) => this.handleAdditionalCost(d)}
          /> */}
          {/* {parseFloat(this.props.additionalCost) > 0 && (
            <Form.TextArea
              label="Reason(s) For Additional Cost"
              value={this.props.additionalCostNote}
              required
              onBlur={(e) => {
                this.props.dispatch(
                  updateCalculatorData(id, {
                    additional_cost_note: e.target.value,
                  })
                );
              }}
              onChange={(e, d) =>
                this.props.dispatch(setAdditionalCostNote(d.value, id))
              }
            />
          )} */}
          <AddressLookup
            address1={address.address_1}
            address2={address.address_2}
            city={address.city}
            state={address.state}
            useTaxStates={true}
            zip={address.zip}
            county={address.county}
            onBlur={this.onAddressBlur}
            onChange={this.onAddressChange}
            onError={this.onAddressError}
            onSelect={this.onAddressSelect}
          />
          {this.state.error && (
            <Message
              header="There was a problem"
              negative
              content={this.state.error}
              icon="exclamation"
            />
          )}
          {!this.state.showPlans && (
            <Button
              disabled={submitDisabled()}
              primary
              content="See Payment Plans"
              icon="arrow right"
              labelPosition="right"
              size="huge"
              fluid
              onClick={this.calculatePayment}
            />
          )}
        </Form>
        {this.state.showPlans && (
          <TermPicker
            additionalCost={this.props.additionalCost}
            isFinancial={this.props.isFinancial}
            onClick={this.onTermClick}
            plans={this.state.plans}
            selectedTerm={this.props.term ? this.props.term.term : null}
            taxRate={this.state.taxRate}
            zip={this.props.zip}
          />
        )}
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return {
    additionalCost: state.term.additionalCost,
    additionalCostNote: state.term.additionalCostNote,
    address: state.address,
    county: state.address.county,
    dealerId: state.dealer ? state.dealer.id : null,
    downPaymentOverrideAmount: state.downPaymentOverrideAmount,
    id: state.id,
    isFinancial: state.dealer ? state.dealer.is_financial : false,
    downPayment: state.term.downPayment,
    payment: state.payment,
    purchaseReserveReduction: state.term.purchaseReserveReduction,
    state: state.address.state ? state.address.state : state.term.taxState,
    systems: state.systems,
    term: state.term.selected,
    zip: state.address.zip ? state.address.zip : state.term.taxZip,
  };
}

export default connect(mapStateToProps)(Term);
